import React from "react";
import ProjectDetail from "../../assets/Icons/projectDetails.png";
import "./tiles.css";
export default function Tiles() {
  return (
    <div className="card card-none-border">
      <div className="card-body card-bd">
        <div className="img-cntainer">
          <img
            className="img-section my-2"
            src={ProjectDetail}
            width={60}
            height={58}
          />
        </div>
        <div className="mt-2 card-title">Project Details</div>
      </div>
    </div>
  );
}
